import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/print.css";
import { PasswordGate } from "./components/password-gate";

// Prevent ResizeObserver errors from reaching the runtime error plugin
window.addEventListener('error', (event) => {
  // Specifically handle ResizeObserver errors with null error objects
  if (event.error === null && event.message?.includes('ResizeObserver')) {
    event.preventDefault(); // Prevent this from propagating to the runtime error plugin
    event.stopImmediatePropagation();
    return;
  }
  
  // Log other actual errors for debugging
  if (event.error !== null) {
    // Handle JavaScript errors silently in production
  }
});

window.addEventListener('unhandledrejection', (event) => {
  // Handle null promise rejections
  if (event.reason === null) {
    event.preventDefault();
    return;
  }
  // Handle promise rejections silently in production
});

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  
  // Check if password gate should be enabled (defaults to true in production)
  const isProduction = import.meta.env.PROD;
  const passwordGateEnabled = import.meta.env.VITE_ENABLE_PASSWORD_GATE !== 'false';
  
  createRoot(rootElement).render(
    <PasswordGate enabled={isProduction && passwordGateEnabled}>
      <App />
    </PasswordGate>
  );
} catch (error) {
  // Handle React render errors silently in production
}
